const HP_PAGE_TYPE = 'hp'; // Homepage
const SLP_PAGE_TYPE = 'slp'; // Search Landing page
const MLP_PAGE_TYPE = 'mlp'; // Merchandising Landing page
const SERP_PAGE_TYPE = 'serp'; // Search Engine Results page
const PDP_PAGE_TYPE = 'pdp'; // Property Details page
const TBP_PAGE_TYPE = 'tbp'; // Trip Boards page

const PAGE_TYPES = [
    HP_PAGE_TYPE,
    SLP_PAGE_TYPE,
    MLP_PAGE_TYPE,
    SERP_PAGE_TYPE,
    PDP_PAGE_TYPE,
    TBP_PAGE_TYPE
];

function hasPageType(PAGE_TYPE, system) {
    let {
        options: {
            pageType
        }
    } = system;

    pageType = `${pageType}`.toLowerCase();

    return pageType === PAGE_TYPE;
}

function hasHPPageType(system) {
    return hasPageType(HP_PAGE_TYPE, system);
}

/* istanbul ignore next */
function hasSLPPageType(system) {
    return hasPageType(SLP_PAGE_TYPE, system);
}

/* istanbul ignore next */
function hasMLPPageType(system) {
    return hasPageType(MLP_PAGE_TYPE, system);
}

/* istanbul ignore next */
function hasSERPPageType(system) {
    return hasPageType(SERP_PAGE_TYPE, system);
}

/* istanbul ignore next */
function hasPDPPageType(system) {
    return hasPageType(PDP_PAGE_TYPE, system);
}

/* istanbul ignore next */
function hasTBPPageType(system) {
    return hasPageType(TBP_PAGE_TYPE, system);
}

export {
    HP_PAGE_TYPE,
    SLP_PAGE_TYPE,
    MLP_PAGE_TYPE,
    SERP_PAGE_TYPE,
    PDP_PAGE_TYPE,
    TBP_PAGE_TYPE,
    PAGE_TYPES,
    hasHPPageType,
    hasSLPPageType,
    hasMLPPageType,
    hasSERPPageType,
    hasPDPPageType,
    hasTBPPageType
};
